// Cambridge A2 Flyers vocab.js — Week 37
export default {
  vocab: [
  {
    "word": "annual",
    "definition_en": "occurring once every year",
    "definition_vi": "hàng năm",
    "example": "Our school holds its annual Sports Day in May.",
    "ipa": "/ˈæn.ju.əl/"
  },
  {
    "word": "stadium",
    "definition_en": "a sports arena with tier seating for spectators",
    "definition_vi": "sân vận động",
    "example": "The crowded sports stadium was loud.",
    "ipa": "/ˈsteɪ.di.əm/"
  },
  {
    "word": "relay",
    "definition_en": "a race between teams where each member runs a part",
    "definition_vi": "chạy tiếp sức",
    "example": "Leo ran the last leg of the 4x100m relay.",
    "ipa": "/ˈriː.leɪ/"
  },
  {
    "word": "baton",
    "definition_en": "a short stick passed from runner to runner in a relay",
    "definition_vi": "gậy tiếp sức",
    "example": "Pass the baton smoothly without dropping it.",
    "ipa": "/ˈbæt.ɒn/"
  },
  {
    "word": "accelerate",
    "definition_en": "begin to move more quickly; gain speed",
    "definition_vi": "tăng tốc",
    "example": "Accelerate quickly down the straight track.",
    "ipa": "/əkˈsel.ə.reɪt/"
  },
  {
    "word": "sprint",
    "definition_en": "run at full speed over a short distance",
    "definition_vi": "chạy nước rút",
    "example": "The first runner began to sprint fast.",
    "ipa": "/sprɪnt/"
  },
  {
    "word": "smoothly",
    "definition_en": "in a even and regular way without sudden movements",
    "definition_vi": "mượt mà",
    "example": "The baton handoff went very smoothly.",
    "ipa": "/ˈsmuːð.li/"
  },
  {
    "word": "cheering",
    "definition_en": "shouting for joy or in praise or encouragement",
    "definition_vi": "tiếng reo hò",
    "example": "Cheering spectators filled the stadium stands.",
    "ipa": "/ˈtʃɪə.rɪŋ/"
  },
  {
    "word": "podium",
    "definition_en": "a raised platform on which winners receive medals",
    "definition_vi": "bục nhận giải",
    "example": "The team stood proudly on the gold podium.",
    "ipa": "/ˈpəʊ.di.əm/"
  },
  {
    "word": "teammate",
    "definition_en": "a fellow member of a sports team",
    "definition_vi": "đồng đội",
    "example": "Leo cheered loudly for his teammate.",
    "ipa": "/ˈtiːm.meɪt/"
  },
  {
    "word": "olympic",
    "definition_en": "relating to the ancient or modern Olympic Games",
    "definition_vi": "thuộc Olympic",
    "example": "Olympic runners train for many years.",
    "ipa": "/əˈlɪm.pɪk/"
  },
  {
    "word": "athlete",
    "definition_en": "a person who is proficient in sports and physical exercise",
    "definition_vi": "vận động viên",
    "example": "More than 200 athletes joined the games.",
    "ipa": "/ˈæθ.liːt/"
  },
  {
    "word": "velocity",
    "definition_en": "the speed of something in a given direction",
    "definition_vi": "vận tốc",
    "example": "Smooth acceleration increases velocity.",
    "ipa": "/vəˈlɒs.ə.ti/"
  },
  {
    "word": "stamina",
    "definition_en": "the ability to sustain prolonged physical effort",
    "definition_vi": "sức bền",
    "example": "Long distance running requires high stamina.",
    "ipa": "/ˈstæm.ɪ.nə/"
  },
  {
    "word": "victory",
    "definition_en": "an act of defeating an opponent in a competition",
    "definition_vi": "chiến thắng",
    "example": "The team celebrated their relay victory.",
    "ipa": "/ˈvɪk.tər.i/"
  },
  {
    "word": "competition",
    "definition_en": "an event in which people compete against each other",
    "definition_vi": "cuộc thi đấu",
    "example": "The Sports Day competition was intense.",
    "ipa": "/ˌkɒm.pəˈtɪʃ.ən/"
  },
  {
    "word": "finish-line",
    "definition_en": "a line marking the end of a race",
    "definition_vi": "vạch đích",
    "example": "Leo crossed the finish-line first.",
    "ipa": "/ˈfɪn.ɪʃ ˌlaɪn/"
  },
  {
    "word": "medal",
    "definition_en": "a metal disc awarded to a sports winner",
    "definition_vi": "huy chương",
    "example": "He wore a shiny gold medal around his neck.",
    "ipa": "/ˈmed.əl/"
  },
  {
    "word": "momentum",
    "definition_en": "the quantity of motion of a moving body",
    "definition_vi": "động năng tiếp sức",
    "example": "Keep your running momentum into the turn.",
    "ipa": "/məˈmen.təm/"
  },
  {
    "word": "teamwork",
    "definition_en": "the combined action of a group of people",
    "definition_vi": "tinh thần đồng đội",
    "example": "Scientific teamwork led them to victory.",
    "ipa": "/ˈtiːm.wɜːk/"
  }
]
};
